var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndcall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10730",
    "data-name": "Group 10730",
    transform: "translate(-3221 -707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mainendcall",
    transform: "translate(3221 707)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#ff5353"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22529",
    "data-name": "Path 22529",
    d: "M51.077,40.442h2.771a3.344,3.344,0,0,0,3.539-3.111V35.755a4.76,4.76,0,0,0-2.481-4.017A30.126,30.126,0,0,0,39.693,28a30.11,30.11,0,0,0-15.212,3.739A4.76,4.76,0,0,0,22,35.755v1.577a3.344,3.344,0,0,0,3.539,3.111h2.771a2.51,2.51,0,0,0,2.654-2.333v-2.12a1.173,1.173,0,0,1,.826-1.092,25.422,25.422,0,0,1,15.807,0,1.173,1.173,0,0,1,.826,1.092v2.12a2.51,2.51,0,0,0,2.654,2.333Z",
    transform: "translate(3221.307 712.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndcall);
export default __webpack_public_path__ + "static/media/endcall.b520a06cce0f45a78c7407a2d28c314e.svg";
export { ForwardRef as ReactComponent };